import React, { useState } from 'react'
import ActivitiesLibrary from '../Pages/ActivitiesLibrary'
import Activity from '../Pages/Activity'
import { Drawer } from 'rsuite'
import styled from 'styled-components'

const MyDrawer = styled(Drawer)`
-webkit-animation: slide-in 0.7s forwards;
.rs-drawer-content {
  overflow: auto;
},
`

const ActivityPickerModal = props => {
  const {
    isActivityPickerVisible, setActivityPickerVisible,
    onSelectActivity, goals
  } = props
  const [isActivityDescriptionShown, setActivityDescriptionShown] = useState(false)
  const [selectedActivity, setSelectedActivity] = useState(null)
  // if (previewActivity) {
  //   setSelectedActivity('X_QthxAAAASq7KL6')
  //   setActivityDescriptionShown(true)
  // }
  return (
    <div style={{ overflow: 'auto' }}>
      <MyDrawer
        size='lg'
        show={isActivityPickerVisible}
        onHide={() => {
          setActivityPickerVisible(false)
          setActivityDescriptionShown(false)
          setSelectedActivity(null)
        }}
      >
        {isActivityDescriptionShown
          ? <Activity
            selectedActivity={selectedActivity}
            setActivityPickerVisible={setActivityPickerVisible}
            onSelectActivity={onSelectActivity}
            setActivityDescriptionShown={setActivityDescriptionShown}
          />
          : <ActivitiesLibrary
            setActivityDescriptionShown={setActivityDescriptionShown}
            isActivityPickerVisible={isActivityPickerVisible}
            setSelectedActivity={setSelectedActivity}
            goals={goals}
          />}
      </MyDrawer>
    </div>
  )
}

export default ActivityPickerModal
